import React, { useState } from 'react';
import Step1VerifyDetails from '../../../check-out/VerifyCheckoutDetails';
import Step2Payment from '../../../PaymentScreen/CheckoutPayment';
import Step3CheckoutComplete from '../../../PaymentScreen/CheckoutSuccess';

const BookingCheckIn = () => {
  const [currentStep, setCurrentStep] = useState(1);

  // Steps configuration with manual widths
  const steps = [
    {
      id: 1,
      title: 'Verify Details',
      description: 'Please verify the details of your stay',
      width: '15%',
    },
    {
      id: 2,
      title: 'Payment',
      description: 'Complete your checkout payment',
      width: '50%',
    },
    {
      id: 3,
      title: 'Checkout',
      description: '',
      width: '100%',
    },
  ];

  const handleNextStep = () => {
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1VerifyDetails onNext={handleNextStep} />;
      case 2:
        return <Step2Payment onNext={handleNextStep} onPrev={handlePrevStep} />;
      case 3:
        return <Step3CheckoutComplete />;
      default:
        return null;
    }
  };

  // Get the progress width for the current step
  const progressWidth = steps.find((step) => step.id === currentStep)?.width || '0%';

  return (
    <div className="min-h-screen bg-white p-4 mt-16 md:p-6">
      <div className="mx-auto bg-white rounded-lg border border-gray-200 overflow-hidden w-full">
        {/* Progress Steps */}
        <div className="p-4 border-b border-gray-200 bg-gray-50">
          <div className="flex justify-between relative">
            {steps.map((step, index) => (
              <div
                key={step.id}
                className="flex flex-col items-center z-10"
                style={{ width: `${100 / steps.length}%` }}
              >
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${
                    currentStep >= step.id ? 'border-black bg-black' : 'border-gray-300 bg-gray-100'
                  }`}
                >
                  <span
                    className={`text-lg font-medium ${
                      currentStep >= step.id ? 'text-white' : 'text-gray-500'
                    }`}
                  >
                    {step.id}
                  </span>
                </div>
                <span
                  className={`text-sm mt-1 text-center font-medium ${
                    currentStep >= step.id ? 'text-black' : 'text-gray-500'
                  }`}
                >
                  {step.title}
                </span>
              </div>
            ))}
            <div className="absolute top-5 left-0 right-0 h-1 bg-gray-200 mx-10">
              <div
                className="h-1 bg-black transition-all duration-300"
                style={{ width: progressWidth }}
              ></div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="p-4 md:p-6">{renderCurrentStep()}</div>
      </div>
    </div>
  );
};

export default BookingCheckIn;

// import React, { useState } from "react";
// import Step1VerifyDetails from "../../../check-out/VerifyCheckoutDetails";
// import Step2Payment from "../../../PaymentScreen/CheckoutPayment";
// import Step3CheckoutComplete from "../../../PaymentScreen/CheckoutSuccess";

// const BookingCheckIn = () => {
//   const [currentStep, setCurrentStep] = useState(1);

//   // Steps configuration
//   const steps = [
//     {
//       id: 1,
//       title: "Verify Details",
//       description: "Please verify the details of your stay",
//     },
//     {
//       id: 2,
//       title: "Payment",
//       description: "Complete your checkout payment",
//     },
//     {
//       id: 3,
//       title: "Checkout",
//       description: "",
//     },
//   ];

//   const handleNextStep = () => {
//     if (currentStep < steps.length) {
//       setCurrentStep(currentStep + 1);
//     }
//   };

//   const handlePrevStep = () => {
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1);
//     }
//   };

//   const renderCurrentStep = () => {
//     switch (currentStep) {
//       case 1:
//         return <Step1VerifyDetails onNext={handleNextStep} />;
//       case 2:
//         return <Step2Payment onNext={handleNextStep} onPrev={handlePrevStep} />;
//       case 3:
//         return <Step3CheckoutComplete />;
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="min-h-screen bg-white p-4 mt-16 md:p-6">
//       <div className="mx-auto bg-white rounded-lg border border-gray-200 overflow-hidden w-full">
//         {/* Progress Steps */}
//         <div className="p-4 border-b border-gray-200 bg-gray-50">
//           <div className="flex justify-between relative">
//             {steps.map((step, index) => (
//               <div
//                 key={step.id}
//                 className="flex flex-col items-center z-10"
//                 style={{ width: `${100 / steps.length}%` }}
//               >
//                 <div
//                   className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${
//                     currentStep >= step.id
//                       ? "border-black bg-black"
//                       : "border-gray-300 bg-gray-100"
//                   }`}
//                 >
//                   <span
//                     className={`text-lg font-medium ${
//                       currentStep >= step.id ? "text-white" : "text-gray-500"
//                     }`}
//                   >
//                     {step.id}
//                   </span>
//                 </div>
//                 <span
//                   className={`text-sm mt-1 text-center font-medium ${
//                     currentStep >= step.id ? "text-black" : "text-gray-500"
//                   }`}
//                 >
//                    {step.title}
//                 </span>
//               </div>
//             ))}
//             <div className="absolute top-5 left-0 right-0 h-1 bg-gray-200 mx-10">
//               <div
//                 className="h-1 bg-black transition-all duration-300"
//                 style={{
//                   width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
//                 }}
//               ></div>
//             </div>
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="p-4 md:p-6">{renderCurrentStep()}</div>
//       </div>
//     </div>
//   );
// };

// export default BookingCheckIn;
